<template>
  <v-form ref="form" v-model="valid">
    <v-row style="padding-bottom: 120px;">
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Welcome to the Q&A portion of your review
          </v-card-title>
          <v-card-text>
            There are {{ questionCount }} total questions spread across
            {{ sectionCount }} sections. Each answer is saved automatically. You
            can edit your answers at anytime prior to clicking submit. After you
            click submit, your answers will be made visible to your direct
            manager and company admin. Let's get started!
          </v-card-text>
          <v-card-actions v-if="!started">
            <v-btn color="performance" @click="started = true">
              Start Q&A Review
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" v-if="started">
        <annual-review-section
          v-for="(section, i) in annualreview.sections"
          :key="i"
          :section="section"
        >
        </annual-review-section>
      </v-col>
      <v-col
        cols="12"
        v-if="
          annualreview.manager.id == profile.id &&
            completed_answers.length == question_count
        "
      >
        <annual-review-assessment-section></annual-review-assessment-section>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
import AnnualReviewSection from "@/components/annualreviews/AnnualReviewSection";
import AnnualReviewAssessmentSection from "@/components/annualreviews/AnnualReviewAssessmentSection";
export default {
  name: "AnnualReviewQuestions",
  components: { AnnualReviewSection, AnnualReviewAssessmentSection },
  data: () => ({
    started: false,
    valid: false,
    saving: false
  }),
  computed: {
    sectionCount() {
      return this.annualreview.sections.length;
    },
    questionCount() {
      return this.question_count;
    },
    ...mapGetters({
      annualreview: "annualreview/annualreview",
      question_count: "annualreview/question_count",
      profile: "profile/profile",
      completed_answers: "annualreview/completed_answers"
    })
  },
  mounted() {
    this.started = this.completed_answers.length > 0;
  },
  methods: {
    async save() {
      if (
        await this.$root.$confirm(
          "Submit Q&A Review",
          "Are you sure you want to complete your review? You will not be able to change any of your responses after this point.",
          { color: "info" }
        )
      ) {
        this.saving = true;
        this.$store
          .dispatch("annualreview/completeQuestions")
          .then(() => {
            this.$emit("save");
            this.$root.$snackbarSuccess("Q&A Review submitted");
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while submitting your review."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
